import { INPUT_TYPES } from '../utils/constants.js';
export default {
    title: `Show preview poster should be kept after object load`,
    isRelevant: () => true,
    type: INPUT_TYPES.BOOLEAN,
    default: false,
};
//# sourceMappingURL=behaviourParams_item_threeDimensionalScene_keepPosterAfterObjectLoad.js.map